<template>
    <v-app id="inspire">
        <v-app-bar app color="#395384" flat>
            <v-container class="py-0 fill-height">
                <!-- Sidebar para moviles ( < = 768 px de ancho)(Solo contiene el boton) -->
                <div class="movilSidebar movilSidebarBtn">
                    <v-btn dark @click.stop="drawer = !drawer">
                        <v-icon dark>mdi mdi-menu</v-icon>
                    </v-btn>
                </div>
                <v-spacer></v-spacer>
                <div class="normalHeaderbar">
                    <v-btn v-for="(menuItem, index) in menuItems" :key="index" :to="menuItem.link" text class="white--text">
                        {{ menuItem.title }}
                    </v-btn>
                </div>
                <div class="movilSidebar movilSidebarBtn">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mx-2" fab dark small color="black" v-bind="attrs" v-on="on">
                                <v-icon dark>mdi mdi-menu</v-icon>
                            </v-btn>
                        </template>
                        <v-list>

                            <v-list-item v-for="(menuItem, index) in menuItems" :key="index" :to="menuItem.link">
                                <v-list-item-title>{{ menuItem.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
                <div class="UserOptions">
                    <v-menu offset-y block>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mx-2" fab dark small color="black" v-bind="attrs" v-on="on">
                                <v-icon dark>mdi mdi-account</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-row align="center">
                                <v-list-item>
                                    <v-col cols="12" class="text-center">
                                        <v-list-item-avatar size="100">
                                            <v-img src="https://cdn.vuetifyjs.com/images/john.png"></v-img>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title class="text-h4">
                                                ¡Hola, Sebastian!
                                            </v-list-item-title>
                                            <v-list-item-subtitle>john@vuetifyjs.com</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-col>
                                </v-list-item>
                            </v-row>
                        </v-list>
                        <v-divider></v-divider>
                        <v-list>
                            <v-btn text @click="logout" block>
                                <v-list-item class="d-flex justify-center">
                                    <v-icon>mdi-logout</v-icon>
                                    <span class="text-h6" style="margin-left: 12px;">Salir</span>
                                </v-list-item>
                            </v-btn>
                        </v-list>
                    </v-menu>
                </div>
            </v-container>
        </v-app-bar>
        <v-navigation-drawer v-model="drawer" absolute temporary class="movilSidebar">
            <v-list class="rounded-lg" nav shaped>
                <v-list nav shaped>
                    <v-list-item v-for="(Icatego, IndeCatindex) in IndependentCategories" :key="IndeCatindex"
                        @click="selectedComponent = Icatego.component" link>
                        <v-list-item-action>
                            <v-icon>{{ Icatego.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{ Icatego.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-list-group v-for="(category, index) in categories" :key="index" v-model="category.active"
                    :prepend-icon="category.icon" link active-class="indigo--text" multiple>
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>{{ category.title }}</v-list-item-title>
                        </v-list-item-content>
                    </template>

                    <v-list-item v-for="(item, itemIndex) in category.items" :key="itemIndex"
                        @click="selectedComponent = item.component">
                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
            </v-list>
        </v-navigation-drawer>
        <v-main class="grey lighten-3" style="padding: 20px 20px 20px;">
            <v-row>
                <div class="normalSidebar ">
                    <v-col>
                        <v-sheet class="rounded-lg">
                            <v-list class="rounded-lg" nav shaped>
                                <v-list nav shaped>
                                    <v-list-item v-for="(Icatego, IndeCatindex) in IndependentCategories"
                                        :key="IndeCatindex" @click="selectedComponent = Icatego.component" link>
                                        <v-list-item-action>
                                            <v-icon>{{ Icatego.icon }}</v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ Icatego.title }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                                <v-list-group v-for="(category, index) in categories" :key="index" v-model="category.active"
                                    :prepend-icon="category.icon" link active-class="indigo--text" multiple>
                                    <template v-slot:activator>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ category.title }}</v-list-item-title>
                                        </v-list-item-content>
                                    </template>

                                    <v-list-item v-for="(item, itemIndex) in category.items" :key="itemIndex"
                                        @click="selectedComponent = item.component">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-group>
                            </v-list>
                        </v-sheet>
                    </v-col>
                </div>



                <v-col>
                    <v-sheet min-height="75vh" rounded="lg" style="width: 100%; height: auto;">
                        <component v-if="selectedComponent" :is="selectedComponent"></component>
                    </v-sheet>
                </v-col>
            </v-row>

        </v-main>
    </v-app>
</template>
  
<script>


import Dashboard from "../components/Dashboard.vue";
import Inicio from "../components/Inicio/Inicio.vue";
import Calendario from "../components/Calendar/Calendario.vue";
import Clientes from "../components/Clients/Clientes.vue";
import Empleados from "../components/Employees/Empleados.vue";
import Contratos from "../components/Contratos/Contratos.vue";
import Archivos from "../components/Recursos/Archivos.vue";

import Documentos from "../components/Recursos/Documentos.vue";


// Importa la función necesaria desde firebase
import { getAuth, signOut } from 'firebase/auth';


export default {
    data: () => ({
        components: {
            Clientes,
            Contratos,
            Empleados,
        },
        drawer: null,
        rail: true,
        railHeader: true,
        loading: true,
        selectedGroup: null,
        selectedComponent: Inicio,
        links: ['Dashboard', 'Messages', 'Profile', 'Updates'],
        menuItems: [
            { title: 'Inicio', link: "Contratos" },
            { title: 'Productos', link: '/productos' },
            { title: 'Servicios', link: '/servicios' },
            // Agrega más elementos del menú aquí
        ],
        perfilItems: [
            { title: 'Perfil', icon: 'mdi-account-circle', link: 'Contratos' },
            { title: 'Configuracion', icon: 'mdi-cog', link: '' },
            { title: 'Acerca de', icon: 'mdi-information', link: '' },
            { title: 'Salir', icon: 'mdi-logout', click: 'logout' }
        ],
        IndependentCategories: [
            { title: 'Inicio', component: Inicio, icon: 'mdi-home' },
            { title: 'Calendario', component: Calendario, icon: 'mdi-calendar' },
        ],
        categories: [

            {
                icon: 'mdi-file-document-edit',
                items: [
                    { title: 'Contratos', component: Contratos },
                    { title: 'Historial de contratos', component: null },
                    { title: 'Historial de contratos', component: null },
                    { title: 'Pagos', component: null },
                ],
                title: 'Contratos',
            },
            {
                icon: 'mdi-account-group',
                items: [
                    { title: 'Manejo de clientes', component: Clientes },

                ],
                title: 'Clientes',
            },
            {
                icon: 'mdi-account-tie',
                items: [
                    { title: 'Manejo de empleados', component: Empleados },
                ],
                title: 'Empleados',
            },
            {
                icon: 'mdi-lock',
                items: [
                    { title: 'Asignar permisos', component: null },
                ],
                title: 'Permisos',
            },
            {
                icon: 'mdi-file-document-multiple',
                items: [
                    { title: 'Documentos', component: Documentos },
                    { title: 'Archivos', component: Archivos },

                ],
                title: 'Recursos',
            },
        ],
    }),

    methods: {
        // Método para cerrar sesión

        prueba() {
            console.log("Funciona");
        },
        logout() {
            const auth = getAuth();

            // Utiliza la función signOut para cerrar sesión
            signOut(auth)
                .then(() => {
                    // Cierre de sesión exitoso
                    console.log('Usuario desconectado');
                    // Redirecciona al usuario a la página de inicio de sesión, por ejemplo
                    this.$router.push('/');
                })
                .catch((error) => {
                    // Manejo de errores
                    console.error('Error al cerrar sesión:', error.message);
                });
        }
    }
}
</script>

<style>
/* Estilos para pantallas mayores o iguales a 768px (normalSideBar visible, movilBar oculto) */
@media screen and (min-width: 767px) {





    .movilBar,
    .movilSidebar {
        display: none;
        /* Ocultar la clase movilBar */
    }
}

/* Estilos para pantallas menores a 768px (normalSideBar oculto, movilBar visible) */
@media screen and (max-width: 768px) {

    .normalSidebar,
    .normalHeaderbar {
        display: none;
        /* Ocultar la clase normalSideBar */
    }


}
</style>